var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGigs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.951,
    height: 26.951,
    viewBox: "0 0 26.951 26.951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.859,
    y1: 0.901,
    x2: 0.06,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_6",
    "data-name": "Union 6",
    d: "M2.781,26.951A2.785,2.785,0,0,1,0,24.17V6.743A4.3,4.3,0,0,1,.2,5.449l0-.009a4.319,4.319,0,0,1,.52-1.083L2.8,1.238A2.777,2.777,0,0,1,5.116,0h16.72A2.776,2.776,0,0,1,24.15,1.238l2.079,3.119a4.319,4.319,0,0,1,.52,1.083l0,.011a4.31,4.31,0,0,1,.2,1.292V24.17a2.784,2.784,0,0,1-2.781,2.781Zm-.26-13.54V24.17a.261.261,0,0,0,.26.26H24.17a.261.261,0,0,0,.26-.26V13.5c0-4.034,0-5.727,0-6.418H2.521C2.52,7.769,2.52,9.44,2.521,13.412Zm12.215-8.85h8.6L22.053,2.637a.26.26,0,0,0-.217-.116h-7.1ZM4.9,2.637,3.615,4.562h8.6V2.521h-7.1A.26.26,0,0,0,4.9,2.637Zm5.485,12.048a2.781,2.781,0,0,1,0-5.562h6.184a2.781,2.781,0,0,1,0,5.562Zm-.26-2.781a.26.26,0,0,0,.26.26h6.184a.26.26,0,1,0,0-.52H10.383A.261.261,0,0,0,10.123,11.9Z",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGigs);
export default __webpack_public_path__ + "static/media/gigs.6b8b38034048c026a4acb39970e65526.svg";
export { ForwardRef as ReactComponent };